import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
import BuhotextCampaigns from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/buhotext-campaigns'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'buhotext_campaigns',
          component: BuhotextCampaigns,
          meta: {
            permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
          },
        },
      ],
    },
  ],
};
